import blockComponents from '@site/blocks'

export default function contentBlocksQuery() {
  return Object.values(blockComponents)
    .map(block => block.query())
    .join('\n')
}
